import { store } from '@/store';
import { parse } from 'semver';

export default {
  //изменение скидки
  cost_putcostdiscount(data, vue) {
    if (typeof store.state.cost.discounts != 'undefined') {
      store.state.cost.discounts.forEach((discount, index) => {
        if (discount.id == data.data.id) store.commit('setStateObject', ['cost.discounts.' + index, data.data]);
      })
    }
  },
  //удаление скидки
  cost_removecostdiscount(data, vue) {
    if (typeof store.state.finance.operations != 'undefined')
      vue.$root.$emit('refresh-table', 'discounts');
  },
  //добавление скидки
  cost_postcostdiscount(data, vue) {
    if (typeof store.state.finance.operations != 'undefined')
      vue.$root.$emit('refresh-table', 'discounts');
  },


  //Добавление цены на перевозку
  cost_postcostprice(data, vue) {
    if (!data || !data.data || !data.data.id || !store.state.cost || !store.state.cost.prices || store.state.cost.currentPricesPage != 1) return;
    store.dispatch('cost/getPrice', {id: data.data.id}).then(r => {
      if (!r || !r.id) return;
      r.routerLink = { name: 'Price', params: { price_id: r.id }, query: vue.$route.query};
      store.commit('cost/unshiftPrice', Object.assign({}, r));
    });
    //vue.$root.$emit('refresh-table', 'prices');
  },
  //Изменение цены на перевозку
  cost_putcostprice(data, vue) {
    if (!data || !data.data || !data.data.id || !store.state.cost || !store.state.cost.prices) return;
    store.dispatch('cost/getPrice', {id: data.data.id}).then(r => {
      if (!r || !r.id) return;
      let price = Object.assign({}, r);
      price.routerLink = { name: 'Price', params: { price_id: price.id }, query: vue.$route.query};
      let i = store.state.cost.prices.findIndex(price => parseInt(price.id) == parseInt(data.data.id));
      store.commit('setStateObject', ['cost.prices.' + i, price]);
    });
  },
  //Удаление цены на перевозку
  cost_deletecostprice(data, vue) {
    if (!data || !data.data || !data.data.id || !store.state.cost || !store.state.cost.prices) return;
    let i = store.state.cost.prices.findIndex(price => parseInt(price.id) == parseInt(data.data.id));
    if (i || parseInt(i) === 0) store.commit('deleteStateObject', ['cost.prices', i]);
  },


  //Добавление цены на экспедирование
  cost_postforwardingprice(data, vue) {
    if (!data || !data.data || !data.data.id || !store.state.cost || !store.state.cost.forwarding_prices || store.state.cost.currentPricesPage != 1) return;
    store.dispatch('cost/getForwardingPrice', {id: data.data.id}).then(r => {
      if (!r || !r.id) return;
      r.routerLink = { name: 'ForwardingPrice', params: { price_id: r.id }, query: vue.$route.query};
      store.commit('cost/unshiftForwardingPrice', Object.assign({}, r));
    });
    //vue.$root.$emit('refresh-table', 'prices');
  },
  //Изменение цены на экспедирование
  cost_putforwardingprice(data, vue) {
    if (!data || !data.data || !data.data.id || !store.state.cost || !store.state.cost.forwarding_prices) return;
    store.dispatch('cost/getForwardingPrice', {id: data.data.id}).then(r => {
      if (!r || !r.id) return;
      let price = Object.assign({}, r);
      price.routerLink = { name: 'ForwardingPrice', params: { price_id: price.id }, query: vue.$route.query};
      let i = store.state.cost.forwarding_prices.findIndex(price => parseInt(price.id) == parseInt(data.data.id));
      store.commit('setStateObject', ['cost.forwarding_prices.' + i, price]);
    });
  },
  //Удаление цены на экспедирование
  cost_deleteforwardingprice(data, vue) {
    if (!data || !data.data || !data.data.id || !store.state.cost || !store.state.cost.forwarding_prices) return;
    let i = store.state.cost.forwarding_prices.findIndex(price => parseInt(price.id) == parseInt(data.data.id));
    if (i || parseInt(i) === 0) store.commit('deleteStateObject', ['cost.forwarding_prices', i]);
  },
  

  
  //Добавление настройки сетки негабарита  
  deals_postdealsextrasize(data, vue) {
    if (typeof store.state.cost.extrasizes != 'undefined')
      vue.$root.$emit('refresh-table', 'freightextrasize');
  },

  //Изменение настройки сетки негабарита
  deals_putdealsextrasize(data, vue) {
    if (typeof store.state.cost.extrasizes != 'undefined')
      vue.$root.$emit('refresh-table', 'freightextrasize');
  },
    
  //Удаление настройки сетки негабарита
  deals_deletedealsextrasize(data, vue) {
    if (typeof store.state.cost.extrasizes != 'undefined')
      vue.$root.$emit('refresh-table', 'freightextrasize');
  },

  //изменение скидки
  cost_putpaymentmethod(data, vue) {
    if (typeof store.state.cost.payment_methods != 'undefined') {
      store.state.cost.payment_methods.forEach((method, index) => {
        if (method.id == data.data.id) store.commit('setStateObject', ['cost.payment_methods.' + index, data.data]);
      })
    }
  },
  //удаление скидки
  cost_deletepaymentmethod(data, vue) {
    if (typeof store.state.finance.payment_methods != 'undefined')
      vue.$root.$emit('refresh-table', 'paymentmethods');
  },
  //добавление скидки
  cost_postpaymentmethod(data, vue) {
    if (typeof store.state.finance.payment_methods != 'undefined')
      vue.$root.$emit('refresh-table', 'paymentmethods');
  },
    
}


// WEBPACK FOOTER //
// ./src/modules/cost/pusher.js